import React, { Component } from 'react';

import Layout from 'Components/Layout';
import TopBar from '../../components/TopBar';
import VideoBrowser from './VideoBrowser';

export default class VideosList extends Component {
  render() {
    return (
      <Layout
        id="videos-layout"
        dataTest="LayoutVideosList"
        top={<TopBar crumbStack={[{ labelKey: 'app_videos' }]} />}
        main={<VideoBrowser mode="copy" />}
      />
    );
  }
}
